import React from "react";
import Button from "../../components/Button";
import { ModalBox, Overlay } from "./styles";

const ModalConfirmacao = ({ texto, onConfirmar, onCancelar }) => {
  return (
    <Overlay>
      <ModalBox>
        <p>{texto || "Deseja realmente excluir este imóvel?"}</p>
        <div style={{ marginTop: "20px", display: "flex", gap: "10px", justifyContent: "center" }}>
          <Button onClick={onConfirmar}>Sim</Button>
          <Button onClick={onCancelar}>Cancelar</Button>
        </div>
      </ModalBox>
    </Overlay>
  );
};

export default ModalConfirmacao;
